<template>
<Layout>
  <PageHeader :title="title" :items="items" />
  <div class="row">
    <div class="col-lg-12">
      <div class="card min-height">
        <TableLoading v-if="creditNote.publicId === '0'"/>
        <div v-else class="card-body">
          <div class="invoice-title">
            <h4 class="float-end font-size-16">Credit Note: {{creditNote.noteRef}}</h4>
            <div class="mb-4">
              <img
                  src="@/assets/images/KikkomanNameLogo.png"
                  alt="logo"
                  height="20"
              />
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-6">
              <address>
                <strong>From:</strong>
                <br />Kikkoman East Africa <br/>P.O BOX 52781-00100 <br/>Tel: 0790 366 564 or Tel: 0740 949 997 (CS)<br/>Tel: 0110 111 999 (Office)
                <br />Pin P051667186Z
              </address>
              <address class="mt-5">
                <strong>Details:</strong>
                <br />Invoice No #: {{creditNote.order.invoiceId}}
                <br />LPO No #: {{creditNote.order.lpo}}
                <br />Delivery Date: {{creditNote.order.deliveryDate}}
                <br />Delivery Time: {{ creditNote.order.timezone.timezoneName }}
                <br />Ordered By: {{creditNote.order.orderedBy}}
                <br />Payment Due: {{ creditNote.order.paymentDueDate }}
                <br />Order Status: <order-status-component :order_status="creditNote.order.status.orderStatusName"/>
              </address>
            </div>
            <div class="col-6 text-sm-end">
              <address>
                <strong>To:</strong>
                <br /><strong>{{creditNote.order.customer.institutionId.name}}</strong>
                <br />P.O BOX {{ creditNote.order.customer.institutionId.postalCode }}
                <br />Tel {{ creditNote.order.customer.institutionId.phoneNumber }}
                <br />KRA PIN: {{ creditNote.order.customer.institutionId.pin }}
                <br />CUSTOMER CODE: {{ creditNote.order.customer.institutionId.institutionCode }}
              </address>

              <address>
<!--                <strong>Shipped To:</strong>-->
<!--                <br />{{ creditNote.order.customer.name }}-->
<!--                <br />Physical Address: {{ creditNote.order.customer.street }}-->
                <strong>Date: </strong> {{ formatDate(creditNote.createdAt)}}
              </address>

            </div>
          </div>
          <div class="p-2 mt-3">
            <h3 class="font-size-16">Credit Note summary</h3>
          </div>
          <div class="table-responsive">
            <table class="table">
              <thead class="table-light">
              <tr>
                <th style="width: 70px">No.</th>
                <th>Product Name</th>
                <th>Our Ref</th>
                <th>Expiry</th>
                <th>Stock</th>
                <th>Net</th>
                <th>VAT</th>
                <th>Gross</th>
              </tr>
              </thead>
              <tbody v-for="(item, index) in creditNote.creditNoteItems" :key="item.publicId">
              <tr>
                <td>{{ index + 1 }}</td>
                <td>{{item.orderItem.item.productName}}</td>
                <td>{{item.orderItem.item.code}}</td>
                <td>
                  <p v-for="shipment in item.orderItem.shipments" :key="shipment">
                    {{shipment.expiryDate}}
                  </p>
                </td>
                <td>
                  <span v-if="item.itemCount > 0">
                    {{item.itemCount}} unit
                  </span>
                  <span v-else>
                    {{item.itemPieces}} pieces
                  </span>
                  </td>
                <td>Ksh {{item.netItemTotal | formatNumber}}</td>
                <td>Ksh {{item.itemVat | formatNumber}}</td>
                <td>Ksh {{item.grossItemTotal| formatNumber}}</td>
              </tr>
              </tbody>
            </table>
            <div class="row justify-content-between w-100 my-5">
              <div class="col-4"></div>
              <div class="col-4">
                <div class="my-2 pb-2">
                  <strong>Total:</strong>
                  <p class="float-end">Ksh {{creditNote.creditNoteGrossTotal | formatNumber}}</p>
                </div>
                <div class="my-2 pb-2">
                  <strong>Remarks:</strong>
                  <p class="float-end">{{creditNote.remarks}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="d-print-none">
            <div class="float-end button-items">
              <div>
                <button v-if="noteLoading" class="btn btn-info waves-effect waves-light me-1" :disabled="noteLoading">Loading</button>
                <button v-else class="btn btn-info waves-effect waves-light me-1" @click="downloadCreditNote(creditNote.publicId, creditNote.noteRef)"><i class="fa fa-print mr-2"></i><span class="ml-3">&ensp; Download Credit Note</span> </button>
              </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import TableLoading from "@/components/TableLoading";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config.json";
import {routeItems} from "@/router/endpoints";
import {SINGLE_CREDIT_NOTE} from "@/gql/orders";
import OrderStatusComponent from "@/components/orders/order-status-component";
import moment from "moment/moment";
import {downloadFileConfig} from "@/filters/downloadFileConfig";
import {errorToast} from "@/components/successToast";
import {mapActions} from "vuex";
export default {
  page: {
    title: "Single Credit Note",
    meta: [{ name: "description", content: appConfig.description }]
  },
  name: "single_credit_note",
  components: {OrderStatusComponent, PageHeader, TableLoading, Layout},
  data(){
    return {
      title: "Single Credit Note",
      items: [
        {
          text: "Credit Notes",
          href: routeItems.credit_note_route
        },
        {
          text: "Single Credit Note",
          active: true
        }
      ],
      creditNote: {
        publicId: '0',
      },
      noteLoading: false,
    }
  },
  apollo: {
    creditNote: {
      query: SINGLE_CREDIT_NOTE,
      variables(){
        return {
          id: this.$route.params.id
        }
      }
    }
  },
  methods: {
    ... mapActions({
      generateCreditNotePdf: 'http/generateCreditNotePdf',
    }),
    formatDate(date){
      return moment(date).format('DD MMM, YYYY')
    },
    async downloadCreditNote(creditId, creditRef){
      this.noteLoading = true;

      const response = await this.generateCreditNotePdf(creditId)
      if(response.data.type === "application/pdf"){
        downloadFileConfig(response, `Credit Note ${creditRef}.pdf`)
        await this.$apollo.queries.creditNote.refetch()
      }else {
        errorToast('Error generating credit note')
      }
      this.noteLoading = false;
    },
  }
}
</script>

<style scoped>

</style>
